import { chakra, Button as ChakraButton, type ButtonProps } from "@chakra-ui/react"
import { buttonRecipe } from "../../themes"
  
export const Button = chakra(ChakraButton, buttonRecipe)
export type { ButtonProps }